// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WidgetModel } from '../model/sp-widget-model';

@Component({
  selector: 'app-widgets-service-parts',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './widgets-service-parts.component.html',
  styleUrl: './widgets-service-parts.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WidgetsServicePartsComponent {
  @Input() widgets: WidgetModel[] = [];
}
